import React from "react";
import Hero from "../../components/hero";
import "./home.style.css";
import Recommends from "../../components/recommends";
import ExploreTheInterface from "../../components/exploreTheInterface";
import ContactUs from "../../components/contactUs";
import Footer from "../../components/footer";
import Intro from "../../components/intro";
import { Toaster } from "react-hot-toast";

const Home = () => {
  return (
    <div id="home-page-wrapper">
      <Intro />
      <Hero />
      <Recommends />
      <ExploreTheInterface />
      <ContactUs />
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;
